import { useParams } from 'react-router-dom';
import { Financial } from '../pages/Financial';
import { Summary } from '../pages/Summary';
import { Forecast } from '../pages/Forecast';
import { SwotAnalysisPage } from '../pages/SwotAnalysisPage';
import { MasterNav } from './navigation/MasterNav';
import { useSelector } from 'react-redux';
import CompanyHeader from './company/CompanyHeader';
import AnalystCornerPage from '../pages/AnalystCorner';
import ProductSegments from './financial/ProductSegments';
import InstitutionalOwnership from './analyst-corner/InstitutionalOwnership';
import { SEOMeta, getStockSEOMeta } from './SEOMeta';

export function SymbolLayout() {
  const { section, symbol } = useParams();
  const isFullScreen = useSelector((state: any) => state.app.isFullScreen);
  console.log('SymbolLayout render: section=', section, ' symbol=', symbol, ' isFullScreen=', isFullScreen);
  const renderContent = () => {
    switch (section) {
      case 'financials':
        return <Financial />;
      case 'forecast':
        return <Forecast />;
      case 'swot-analysis':
        return <SwotAnalysisPage />;
      case 'analyst-corner':
        return <AnalystCornerPage />;
      case 'ownership':
        return <InstitutionalOwnership />;
      case 'segments':
        return <ProductSegments symbol={symbol} />;
      case 'summary':
      default:
        return <Summary />;
    }
  };

  const active = section ?? 'summary';

  // Generate SEO metadata for the current stock page
  const seoMeta = symbol ? getStockSEOMeta(symbol.toUpperCase(), active) : null;

  return (
    <div className="flex min-h-screen bg-theme-primary overflow-hidden">
      {/* SEO Meta Tags */}
      {seoMeta && (
        <SEOMeta
          title={seoMeta.title}
          description={seoMeta.description}
          keywords={seoMeta.keywords}
          ogImage={seoMeta.ogImage}
          structuredData={seoMeta.structuredData}
        />
      )}

      {!isFullScreen && <MasterNav />}
      <div className={`${isFullScreen ? 'fixed inset-0 z-50' : 'flex-1'} overflow-y-auto scrollbar-hide transition-all duration-300 ease-in-out px-0`}>
        <div className={`${isFullScreen ? 'h-full m-0 p-0' : 'w-full m-0 p-0'}`}>
          {/* Global company info header for all symbol pages */}
          <CompanyHeader />
          {active === 'summary' ? (
            <div className={`mt-3 ${isFullScreen ? 'h-full' : ''}`}>
              <Summary />
            </div>
          ) : (
            <div className={`relative mt-3 rounded-xl shadow-lg border border-theme-tertiary bg-theme-secondary ${isFullScreen ? 'h-full rounded-none' : ''}`}>
              {renderContent()}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}